import { render, staticRenderFns } from "./admin-mailtemplate.vue?vue&type=template&id=f9ae8bf0&"
import script from "./admin-mailtemplate.vue?vue&type=script&lang=js&"
export * from "./admin-mailtemplate.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports